module.exports = __webpack_public_path__ + "img/01.3bee3c94.jpg";